import { Button, makeStyles } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useDefaultModalStyles } from '../../hooks/useDefaultModalStyles';
import Modal from '../common/ModalV9';

export interface IAddReturnUnsavedChangesModalProps {
    isModalVisible: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const useStyles = makeStyles({
    modalContent: {
        maxWidth: '550px',
        fontSize: '12px',
        lineHeight: '16px',
    },
});

const AddReturnUnsavedChangesModal = ({ isModalVisible, onConfirm, onCancel }: IAddReturnUnsavedChangesModalProps) => {
    const { t } = useTranslation();
    const { modalContent } = useStyles();
    const { button } = useDefaultModalStyles();

    const stopDialogEventBubble = (event: React.MouseEvent<HTMLElement>) => {
        // Keep Syncfusion sidebar document-click close from seeing dialog button clicks.
        event.stopPropagation();
    };

    const buttons = (
        <>
            <Button
                appearance='primary'
                size='small'
                aria-label={t('discard').toString()}
                onClick={(event) => {
                    stopDialogEventBubble(event);
                    onConfirm();
                }}
                data-testid='discard-changes-button'
                className={button}
            >
                {t('discard').toString()}
            </Button>
            <Button
                size='small'
                aria-label={t('cancel').toString()}
                onClick={(event) => {
                    stopDialogEventBubble(event);
                    onCancel();
                }}
                data-testid='stay-in-panel-button'
                className={button}
            >
                {t('cancel').toString()}
            </Button>
        </>
    );

    return (
        <Modal
            headerContent={t('discardCalculations')}
            bodyContent={<div className={modalContent}>{t('addReturnsUnsavedChangesWarning')}</div>}
            isOpen={isModalVisible}
            onClose={onCancel}
            showModalCloseButton={false}
            buttons={buttons}
            modalMaxWidthInPixels={600}
            isBlocking={true}
        />
    );
};

export default AddReturnUnsavedChangesModal;
